var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MegasredaContentLayoutBase', {
    scopedSlots: _vm._u([{
      key: "main",
      fn: function () {
        return [_c('PagesNavigatorStreamHeader'), _vm._v(" "), _c('NuxtChild')];
      },
      proxy: true
    }, {
      key: "column",
      fn: function () {
        return [_c('div', {
          staticClass: "flex flex-col tab:grid tab:grid-cols-2 tab:gap-2.5 tab-l:flex"
        }, [_c('BaseRecommendationsStreamsExperts', {
          staticClass: "mt-2.5 tab:mt-0"
        }), _vm._v(" "), _c('MegasredaRecomendedSocial', {
          staticClass: "mt-2.5 tab:mt-0"
        })], 1)];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }